import { useEffect } from 'react';
import type { FieldErrors, UseFormSetFocus } from 'react-hook-form';

export const useErrorAutoscroll = (
  errors: FieldErrors<any>,
  setFocus: UseFormSetFocus<any>
) => {
  useEffect(() => {
    const errorKeys = Object.keys(errors);

    if (errorKeys.length !== 0) {
      const firstError = errorKeys.reduce(
        (field: string | null, a: string | null) => {
          return field && errors[field] ? field : a;
        },
        null
      );

      if (firstError) {
        setFocus(firstError);
      }
    }
  }, [errors, setFocus]);
};
